module.exports = __webpack_public_path__ + "media/images/support-c19dff2e.png";